export const createCourierIntentId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2,'0')).join('');
  return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
};

export const outsideShippingEndpoint = ({apiUrl,merchantId,sourceOrder,source}) => {
  if (sourceOrder) {
    const id = String(sourceOrder.orderId || '').trim();
    if (!['site','balcao','pedidos10'].includes(source) || !id) throw new Error('Abra o pedido original novamente para solicitar a entrega.');
    return `${apiUrl}/api/ifood/shipping/external-orders/${encodeURIComponent(source)}/${encodeURIComponent(id)}/merchants/${encodeURIComponent(merchantId)}/orders`;
  }
  return `${apiUrl}/api/ifood/shipping/merchants/${encodeURIComponent(merchantId)}/orders`;
};
